export default {
  tab: {
    dashboard: '招聘经理看板'
  },
  title: {
    dashboard: '我的候选人筛选和面试',
    rating: '求职者评估表单',
    interview: '求职者面试表单'
  },
  containerTitle: {
    dashboard: {
      candidateInterviews: '候选人面试',
      candidateScreening: '候选人筛选'
    }
  },
  placeholder: {
    candidateName: '候选人姓名'
  },
  label: {
    recruiter: '招聘人员',
    candidate: '候选人',
    status: '状态',
    actions: '操作',
    dateJObEntity: '日期 / 职位 / 公司',
    toDo: '已预约',
    toInterviewed: '待评估',
    completed: '已评估',
    canceled: '已被取消',
    tabToRate: '待评估',
    tabToInterview: '已预约',
    tabCompleted: '已评估',
    tabCanceled: '已取消',
    userName: '电子邮箱',
    firstName: '名',
    lastName: '姓',
    password: '密码',
    createPassword: '创建您的密码',
    rePassword: '确认密码',
    forgetPassword: '忘记密码',
    rating: {
      notRecommended: '不推荐面试',
      Recommended: '推荐面试',
      commentTips: '请查看针对该求职者的评价，然后点击下一步。',
      ratingTips: '请打分',
      overallTips: '请给出对于该求职者整体的评价，添加评论以及评估建议。'
    },
    pending: '待定',
    interview: {
      notRecommended: '不推荐',
      Recommended: '推荐',
      commentTips: '请查看针对该求职者的评价，然后点击下一步。',
      ratingTips: '请打分',
      overallTips: '请给出对于该求职者整体的评价，添加评论以及评估建议。'
    },
    questionLabel: '问题:',
    answerLabel: '答案:',
    ratingLabel: '评分:',
    commentLabel: '评论:',
    tab: {
      rating: {
        comments: 'HR评论',
        resume: '个人简历',
        report: '测评报告',
        rating: '问卷评估',
        overall: '总体评价'
      },
      interview: {
        comments: 'HR评论',
        resume: '个人简历',
        report: '测评报告',
        rating: '面试评估',
        overall: '总体评价'
      }
    },
    comment: '评论',
    organizer: '组织者'
  },
  resume: {
    aiResumeMatchInfo: 'AI匹配度',
    aiSummaryInfo: 'AI简历提炼',
    basicInfo: '基本信息',
    originalResume: '原始简历',
    applyFor: '申请职位',
    jobApplicationDate: '职位申请时间',
    legalName: '求职者姓名',
    emailAddress: '邮箱',
    mobileId: '手机账号',
    stlutation: '称谓',
    birthday: '出生日期',
    gender: '性别',
    location: '户口所在地',
    currentLocation: '当前所在地',
    address: '地址',
    addressOther: '其他地址',
    mobilePhone: '手机号码',
    secondPhone: '其他手机号码',
    chatId: '在线聊天工具',
    socialNetwork: '社交网络',
    expectedSalary: '期望薪资',
    applicantQuestionnaire: '申请人调查问卷',
    hrQuestionnaire: '招聘人员筛选',
    specificQuestions: '特定的问题',
    question: '问题:',
    video: '视频:',
    attachment: '附件:',
    remark: '备注:',
    answer: '答案:',
    referredBy: '推荐信息',
    referralReson: '推荐原因',
    employee: '员工',
    notEmployee: '非员工',
    intern: '实习兼职经验',
    experience: '工作经验',
    education: '教育背景',
    additionalInfo: '附加信息',
    hiringManagerRating: '招聘经理评估',
    workExperience: {
      company: '公司名称',
      jobTitle: '职位名称',
      industry: '行业',
      locaton: '所在地',
      date: '日期',
      salary: '薪资',
      description: '职位描述',
      year: '{year}年',
      month: '{month}月'
    },
    educationInfoLabel: {
      school: '毕业学校',
      degree: '学历和专业',
      date: '日期',
      gpa: '平均绩点',
      academic: '学习排名',
      other: '其他',
      summary: '总结'
    },
    additionInfoLabel: {
      memberships: '社团组织成员',
      awards: '奖励信息',
      hobby: '兴趣爱好',
      lanaguages: '工作语言',
      channel: '申请职位渠道',
      platform: '申请职位平台'
    },
    referralRoleType: {
      employee: '员工',
      candidate: '候选人',
      lead: '潜在候选人',
      prospect: '潜在候选人(我的人才)'
    }
  },
  btn: {
    dashboard: {
      preview: '预览',
      rate: '评估',
      view: '查看',
      reschedule: '改约',
      cancel: '取消'
    },
    toHMDashboard: '登录',
    submit: '提交',
    reset: '重置',
    signOnt: '退出',
    homePage: '操作中心',
    next: '下一步',
    back: '上一步',
    resend: '重新发送我的登录信息',
    download: '点击下载',
    expand: '展开',
    collapse: '收起'
  },
  status: {
    dashboard: {
      comingUp: '已预约',
      needRating: '待评估',
      finish: '已评估',
      cancel: '已取消'
    }
  },
  tips: {
    dashboard: {
      cancel: '想要取消，请联系',
      reschedule: '想要重新预约，请联系',
      noData: '目前没有邀请记录。'
    },
    pleaseRate: '请打分',
    invitcodeError: '邀请码不正确，即将返回首页!',
    ratingSuccess: '评分成功，即将返回首页!',
    pleaseSelect: '请选择'
  },
  interviewInvitation: {
    title: '面试安排',
    label: {
      information: '面试信息：',
      company: '公司',
      job: '职位',
      organizer: '组织者',
      interviewer: '面试官',
      candidate: '候选人',
      status: '状态',
      selectTime: '请选择三个时间段，该时间段将发送给候选人：',
      singleTime: '请选择一个时间段，该时间段将发送给候选人：',
      timeZone: '时区：',
      interviewTime: '面试时间：',
      candidateSelectTime: '待候选人选择时间',
      cancelInterview: '确定取消面试吗？',
      candidateSuggestedNewTime: '候选人请求新时间',
      interviewerSuggestedNewTime: '已建议新的面试时间',
      canceled: '面试已取消',
      interviewConfirm: '请确认最终的面试信息',
      reschedulingByCandidate: '当前面试时间：',
      reschedulingByInterviewer: '已建议的新面试时间：',
      teamsTip: '点击发送按钮，创建teams链接，发送最终的面试邀请邮件。'
    },
    message: {
      duplicateDateTime: '时间段重复，请重新选择',
      confirmSuccess: '建议的面试时间已经成功发送给候选人，一旦确认，我们会马上通知您。如果需要变更，您可以任何时候访问邮件里的链接回来。',
      pendingHrConfirm: '发送成功，请等待面试组织者确认',
      cancelSuccess: '面试取消成功',
      selectInterviewTime: '请至少选择一个面试时间',
      sendSuccess: '发送成功',
      maxSelectScheduleCount: '最多只能选择{maxCount}个时间段',
      placeChangePC: '该面试属于Teams面试，请到PC端操作'
    },
    btn: {
      suggestNewTime: '建议新时间',
      reschedule: '重新预约',
      send: '发送'
    }
  }
}
